import { PREFIX_URL_API } from '@/shared/constants';
import { apiClient } from '@/shared/utils/apiClient';

import type { IApiResponseManageUserFavoritesRemove, TApiManageUserFavoritesRemove } from './types';

export const removeFromFavoriteApi: TApiManageUserFavoritesRemove = (postData) => {
  const url = `${PREFIX_URL_API.MANAGE_USER_FAVORITES}/RemoveFromUserFavorites`;
  return apiClient.post<IApiResponseManageUserFavoritesRemove>(url, postData);
};
